const colors = {
  gradient: {
    button:
      "linear-gradient(90deg, rgba(249,236,49,1) 0%, rgba(38,169,224,1) 50%, rgba(101,45,144,1) 100%)",
  },
  bgColor: {
    gray: "#414142",
    // 로그인 페이지 배경  배경 색
    gray2: "#EEEEEF",
    // 로그인 페이지 버튼 색
    gray3: "#323232",
  },
  fontColor: {
    gray: "#C1BEBE",
    gray2: "#EEEEEF",
    gray3: "#323232",
  },
  color: {
    gray3: "#323232",
    gray4: "#909090",
    gray5: "#707070",
    gray6: "#828283",
  },
  borderColor: {
    gradient:
      "linear-gradient(90deg, rgba(249,236,49,1) 0%, rgba(38,169,224,1) 50%, rgba(101,45,144,1) 100%)",
  },
};

export default colors;
